import { render, staticRenderFns } from "./section_5.vue?vue&type=template&id=4e1a5c9f&scoped=true&"
import script from "./section_5.vue?vue&type=script&lang=js&"
export * from "./section_5.vue?vue&type=script&lang=js&"
import style0 from "./section_5.vue?vue&type=style&index=0&id=4e1a5c9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a5c9f",
  null
  
)

component.options.__file = "section_5.vue"
export default component.exports